<template>
  <a href="#" class="" @click="open">
    <i class="fas fa-search"></i>
  </a>
</template>

<script>
export default {
  name: "search-trigger",

  methods: {
    open() {
      event.preventDefault();

      this.$root.search.opened = !this.$root.search.opened;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Tenants/kendall-mountain/kendall-mountain-SearchTrigger.vue